import { OldMainMenu } from "./types";
import { OldMenuLink } from "./old-menu-link";
import { AnimatePresence, motion } from "motion/react";
import { OldMenuOverlay } from "./old-menu-overlay";
import { useOldMenu } from "./old-menu-context";
import { useLink } from "@made-people/grease-link";
import { useTranslate } from "@made-people/grease-translations";
import { SiteSettingsTriggerWithFlag } from "../../global/site-settings-trigger-with-flag";

export const OldMobileMenu = ({ data }: { data: OldMainMenu }) => {
  const { openMenu, isOpen, activeSubmenu, setActiveSubmenu, closeMenu } =
    useOldMenu();
  const translate = useTranslate();
  const Link = useLink();

  return (
    <>
      <button className="block lg:hidden gap-4" onClick={openMenu}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          className="w-4 h-4"
        >
          <path d="M15.47 16H.53a.51.51 0 01-.37-.15.46.46 0 010-.7.51.51 0 01.37-.15h14.94a.51.51 0 01.37.15.46.46 0 010 .7.51.51 0 01-.37.15zm0-7.73H.53a.55.55 0 01-.37-.14.5.5 0 01-.16-.36.48.48 0 01.16-.35.51.51 0 01.37-.15h14.94a.51.51 0 01.37.15.48.48 0 01.16.35.5.5 0 01-.16.36.55.55 0 01-.37.14zm0-7.27H.53A.51.51 0 01.16.85.48.48 0 010 .5.48.48 0 01.16.15.51.51 0 01.53 0h14.94a.51.51 0 01.37.15.48.48 0 01.16.35.48.48 0 01-.16.35.51.51 0 01-.37.15z" />
        </svg>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div className="w-full right-0 h-[100dvh] fixed bottom-0 left-0 top-0 flex lg:hidden z-[60]">
            <motion.div
              className="bg-[#faf9f6] w-[80vw] h-full z-10  overflow-auto"
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ duration: 0.2, ease: "easeInOut" }}
            >
              <div className="flex flex-col px-4 relative">
                <button className="absolute top-4 right-4" onClick={closeMenu}>
                  <svg
                    data-v-50f8b942=""
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 12 12"
                    className="w-4 h-4"
                  >
                    <path
                      data-v-50f8b942=""
                      d="M11.81 11.18L6.63 6 11.71.82a.65.65 0 00.18-.37.4.4 0 00-.1-.34.45.45 0 00-.29-.11.66.66 0 00-.37.19L6 5.32.91.19A.61.61 0 00.55 0a.45.45 0 00-.34.11.4.4 0 00-.1.34.65.65 0 00.18.37L5.37 6 .18 11.18a.62.62 0 00-.18.37.42.42 0 00.11.34.42.42 0 00.33.11.63.63 0 00.37-.19L6 6.58l5.19 5.23a.6.6 0 00.37.19.44.44 0 00.33-.11.45.45 0 00.11-.34.63.63 0 00-.19-.37z"
                    ></path>
                  </svg>
                </button>
                <span className="font-bold font-secondary text-heading-xl mb-10 mt-10">
                  {translate("Menu_Heading")}
                </span>
                {/* First Column Desktop */}
                {activeSubmenu && (
                  <div className="flex flex-col font-bold mr-10">
                    <button
                      onClick={() => setActiveSubmenu(null)}
                      className="flex gap-5 justify-start items-center mb-2"
                    >
                      <svg
                        data-v-50f8b942=""
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 8.8"
                        className="w-3 h-3 rotate-90"
                      >
                        <path
                          data-v-50f8b942=""
                          d="M15.86.9a.5.5 0 000-.7.49.49 0 00-.69 0L8 7.41.84.14a.5.5 0 00-.7 0A.54.54 0 000 .49a.5.5 0 00.14.35L8 8.8z"
                        ></path>
                      </svg>
                      <h3 className="font-bold">{activeSubmenu?.label}</h3>
                    </button>
                    <div className="flex flex-col font-medium pl-8">
                      {activeSubmenu.link?.href && (
                        <Link
                          href={activeSubmenu.link?.href ?? ""}
                          className="text-black hover:underline underline-offset-4 py-2 font-bold"
                          onClick={closeMenu}
                        >
                          {translate("Menu_View_All")}
                        </Link>
                      )}
                      {activeSubmenu?.subMenu?.map((item, index) => (
                        <Link
                          href={item?.link?.href ?? ""}
                          key={index}
                          onClick={closeMenu}
                          className="text-black hover:underline underline-offset-4 py-2"
                        >
                          {item?.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
                {!activeSubmenu && (
                  <div className="flex flex-col font-bold">
                    {data.primaryMenu.map((item, index) => (
                      <OldMenuLink key={index} {...item} />
                    ))}
                  </div>
                )}

                {!activeSubmenu && (
                  <div className="flex flex-col font-medium mt-4 text-sm">
                    {data.additionalMobileMenu.map((item, index) => (
                      <OldMenuLink key={index} {...item} className="text-sm" />
                    ))}
                  </div>
                )}

                {!activeSubmenu && (
                  <SiteSettingsTriggerWithFlag className="flex items-center gap-1 mt-6 py-2 text-label-sm" />
                )}
              </div>
            </motion.div>
            <OldMenuOverlay />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
